import React from 'react';
import PropTypes from 'prop-types';
import { applySpec } from 'ramda';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import {
  hasSpecialTraits,
  productHighlightTextKey,
} from 'app/features/products/selectors';
import { productSavings } from 'app/features/plans/selectors';
import S from 'app/features/newLanding/components/newProductComparison/Product/ProductHighlightedBlock.styled';
import Text from 'app/components/layout/Text.styled';

const UI = ({ textKey, textKeyVariables, children, hasSpecialTraits }) => (
  <S.ProductHighlightedBlock
    hasSpecialTraits={hasSpecialTraits}
    textKey={textKey}
  >
    {textKey && (
      <S.ProductHighlightedBlock.Title hasSpecialTraits={hasSpecialTraits}>
        <Text
          size="xl"
          isFixedSize
          type={hasSpecialTraits ? 'heavy' : 'semibold'}
        >
          <FormattedMessage id={textKey} values={textKeyVariables} />
        </Text>
      </S.ProductHighlightedBlock.Title>
    )}

    {children}
  </S.ProductHighlightedBlock>
);

UI.propTypes = {
  children: PropTypes.node.isRequired,
  hasSpecialTraits: PropTypes.bool.isRequired,
  textKey: PropTypes.string,
  textKeyVariables: PropTypes.shape({}),
};

UI.defaultProps = {
  textKey: '',
  textKeyVariables: {},
};

const state = {
  hasSpecialTraits,
  textKey: productHighlightTextKey,
  textKeyVariables: applySpec({
    savings: productSavings,
  }),
};

const ProductHighlightedBlock = connect(state)(UI);

export { UI };

export default ProductHighlightedBlock;
